/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rating_Somewhat_SatisfiedInputs */

const sv_rating_somewhat_satisfied = /** @type {(inputs: Rating_Somewhat_SatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganska nöjd`)
};

const en_rating_somewhat_satisfied = /** @type {(inputs: Rating_Somewhat_SatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somewhat satisfied`)
};

/**
* | output |
* | --- |
* | "Somewhat satisfied" |
*
* @param {Rating_Somewhat_SatisfiedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const rating_somewhat_satisfied = /** @type {((inputs?: Rating_Somewhat_SatisfiedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_Somewhat_SatisfiedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_rating_somewhat_satisfied(inputs)
	return en_rating_somewhat_satisfied(inputs)
});